export enum PackageEvent {
  OnViewInit = 'createPackageOnViewInit',
}
